import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=4c9983c1"
import script from "./profile.ts?vue&type=script&lang=js&external"
export * from "./profile.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports